import React from "react";
import { motion } from "framer-motion";

const chapters = [
  {
    n: "01",
    title: "We sell booked appointments, not clicks.",
    body: "Impressions don't pay your lease. Every system we build is measured against one number: new patients who show up in your chair.",
  },
  {
    n: "02",
    title: "One team, fully accountable.",
    body: "No hand-offs, no shared account managers. A strategist, media buyer, designer and developer, all rowing for your practice.",
  },
  {
    n: "03",
    title: "Speed beats everything.",
    body: "Leads contacted in minutes convert far more than leads chased in days. We wire your funnel for instant follow-up from day one.",
  },
  {
    n: "04",
    title: "If we can't win, we walk.",
    body: "We take one practice per zip code and per niche. If we can't move your number, we don't belong in your calendar.",
  },
];

const item = {
  hidden: { opacity: 0, y: 40 },
  show: { opacity: 1, y: 0, transition: { duration: 0.7, ease: [0.22, 1, 0.36, 1] } },
};

export default function Manifesto() {
  return (
    <section id="manifesto" className="py-24 md:py-36 relative">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.6 }}
          className="max-w-3xl mb-16 md:mb-24"
        >
          <div className="font-mono-accent text-[11px] uppercase tracking-[0.25em] text-blue-400 mb-4">
            / The manifesto
          </div>
          <h2 className="font-display text-4xl sm:text-5xl md:text-6xl tracking-tighter font-medium text-white leading-[1.05]">
            Four beliefs we build every account on.
          </h2>
        </motion.div>

        <div className="divide-y divide-white/10 border-t border-white/10">
          {chapters.map((c) => (
            <motion.div
              key={c.n}
              variants={item}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true, margin: "-60px" }}
              className="group grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-10 py-10 md:py-14"
            >
              <div className="md:col-span-2">
                <span className="font-mono-accent text-2xl text-amber-400">{c.n}</span>
              </div>
              <h3 className="md:col-span-6 font-display text-2xl md:text-4xl tracking-tight text-white leading-tight">
                {c.title}
              </h3>
              <p className="md:col-span-4 text-white/55 leading-relaxed md:pt-2">
                {c.body}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
